var React = require('react');

function CommonIconAccount (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13,13A4.5,4.5,0,1,0,8.5,8.5,4.5,4.5,0,0,0,13,13Zm0,2.25c-3,0-9,1.507-9,4.5V22H22V19.75C22,16.757,16,15.25,13,15.25Z","transform":"translate(-4 -4)","fill":"#f5f2ea"}));
}

CommonIconAccount.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = CommonIconAccount;

CommonIconAccount.default = CommonIconAccount;
